import * as React from 'react';
import { multiMint } from '../../multiMint';
import { MintWrite } from './MintWrite';

export function MintList(props) {
  const [config, setConfig] = React.useState(null);

  React.useEffect(() => {
    let qty = props.cart.length;
    if (qty) {
      let newConfig = {
        address: multiMint.addr,
        abi: multiMint.abi,
        functionName: 'mintList',
        args: [props.cart],
        overrides: {
          from: props.connected,
          value: props.value,
        },
      };
      setConfig(newConfig);
    } else {
      setConfig(null);
    }
  }, [props.cart, props.total, props.connected, props.value]);

  return (
    <>
      {config ? (
        <MintWrite
          config={config}
          value={props.value}
          cart={props.cart}
          eth={props.eth}
          resetCart={props.resetCart}
        />
      ) : null}
    </>
  );
}
